let themes=[
    { textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
      headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#17a2b8",//info-color
        // "justify-content":'flex-start',
        // "width":"100%",
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },
   { 
     textStyle:{
          "color":'#00C851',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#ffbb33",//warning-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#dc3545",//danger-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#28a745",//success-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#6c757d",//secondary-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#007bff",//primary-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'#000',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid #000"
      },drawerInsideStyle:{
        "background":"#f8f9fa",//light-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid white"
      },drawerInsideStyle:{
        "background":"#343a40",//dark-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'#000',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid #000"
      },drawerInsideStyle:{
        "background":"#fff",//white-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  },{ 
     textStyle:{
          "color":'white',
          "padding":"5px",
          "margin":0
        },
     headerStyle:{
        "display":"flex",
        "justify-content":'center',
        "width":"100%",
        "border-bottom": "2px solid #000"
      },drawerInsideStyle:{
        "background":"#aa66cc",//secondary-color
      },drawerItemStyle:{
        "display":"flex",
        "justify-content":'flex-start',
        "width":"100%",
      },drawerItemHoverEnterStyle:{
        "cursor": "pointer",
        "background":"#343a40",
        "border":"1px solid transparent",
        "border-radius":"5px"
      },drawerItemHoverExitStyle:{
        "cursor": "pointer",
        "background":"transparent",
        "border":"0px"
      }
  }
  ,{ //my light theme start 10
    textStyle:{
         "color":'#f9f0e7',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f9f0e7"
     },drawerInsideStyle:{
       "background":"#e1cb91",//brown-my-color1 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#343a40",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //11 light-blue-my-color2 
    textStyle:{
         "color":'#000',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f9f0e7"
     },drawerInsideStyle:{
       "background":"#12d3cf",//light-blue-my-color2 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#67eaca",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //12 light-yellow-my-color2
    textStyle:{
         "color":'#000',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ffd19a"
     },drawerInsideStyle:{
       "background":"#fff8a6",//light-yellow-my-color2 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ffc5a1",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //13 light-wheat-my-color2 
    textStyle:{
         "color":'#000',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #d2f3e0"
     },drawerInsideStyle:{
       "background":"#f5fbf1",//light-wheat-my-color2 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ffc5a1",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //14 light-Purple-my-color2 
    textStyle:{
         "color":'#553c8b',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #553c8b"
     },drawerInsideStyle:{
       "background":"#ffeafe",//light-Purple-my-color2 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ccc1ff",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //15 light-blue-my-color
    textStyle:{
         "color":'#866ec7',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #866ec7"
     },drawerInsideStyle:{
       "background":"#b7fbff",//light-blue-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#f1f1f1",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //16 light-gray-red-my-color
    textStyle:{
         "color":'#000',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #000"
     },drawerInsideStyle:{
       "background":"#eeeeee",//light-gray-red-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#c10000",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //17 light-gray-red-2-my-color
    textStyle:{
         "color":'#000',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #000"
     },drawerInsideStyle:{
       "background":"#dedede",//light-gray-red-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ff4949",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //18 light-blue-orange-2-my-color
    textStyle:{
         "color":'#ff502f',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ff502f"
     },drawerInsideStyle:{
       "background":"#5bd1d7",//light-blue-orange-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#004d61",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //19 light-purple-2-my-color
    textStyle:{
         "color":'#484c7f',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #484c7f"
     },drawerInsideStyle:{
       "background":"#f1d4d4",//light-purple-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ac8daf",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //20 light-yellow-2-my-color
    textStyle:{
         "color":'#103c42',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #103c42"
     },drawerInsideStyle:{
       "background":"#ffe837",//light-purple-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#05a19c",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //21 light-wheat-2-my-color
    textStyle:{
         "color":'#293462',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #293462"
     },drawerInsideStyle:{
       "background":"#fff1c1",//light-purple-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#fe5f55",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //22 light-yellow-2-my-color
    textStyle:{
         "color":'#e41749',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #e41749"
     },drawerInsideStyle:{
       "background":"#fff591",//light-yellow-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ff8a5c",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //23 dark-red-my-color
    textStyle:{
         "color":'#ee4540',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ee4540"
     },drawerInsideStyle:{
       "background":"#2d132c",//light-yellow-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#801336",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //24 dark-red2-my-color
    textStyle:{
         "color":'#fff',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #fff"
     },drawerInsideStyle:{
       "background":"#2d132c",//light-yellow-my-color 
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#801336",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //25 dark-purple-my-color
    textStyle:{
         "color":'#ffeafe',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ffeafe"
     },drawerInsideStyle:{
       "background":"#553c8b",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#9ea9f0",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //26 dark-red-gray-my-color
    textStyle:{
         "color":'#eeeeee',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #eeeeee"
     },drawerInsideStyle:{
       "background":"#c10000",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ff4949",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //27 dark-gray-green-my-color
    textStyle:{
         "color":'#d9d872',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #d9d872"
     },drawerInsideStyle:{
       "background":"#454d66",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#009975",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //28 dark-gray-green2-my-color
    textStyle:{
         "color":'#d9d872',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #d9d872"
     },drawerInsideStyle:{
       "background":"#454d66",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#58b368",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //29 dark-blue-pink-my-color
    textStyle:{
         "color":'#ff6768',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ff6768"
     },drawerInsideStyle:{
       "background":"#17223b",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#6b778d",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //30 dark-blue-pink-2-my-color
    textStyle:{
         "color":'#ff6768',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ff6768"
     },drawerInsideStyle:{
       "background":"#17223b",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#263859",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //31 dark-purple-my-color
    textStyle:{
         "color":'#f1d4d4',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f1d4d4"
     },drawerInsideStyle:{
       "background":"#484c7f",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ac8daf",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //32 dark-black-red-my-color
    textStyle:{
         "color":'#f2f6f5',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f2f6f5"
     },drawerInsideStyle:{
       "background":"#525252",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ca3e47",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //33 dark-black-red2-my-color
    textStyle:{
         "color":'#93b5b3',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #93b5b3"
     },drawerInsideStyle:{
       "background":"#525252",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ca3e47",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //34 dark-blue-wheat-my-color
    textStyle:{
         "color":'#fff1c1',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #fff1c1"
     },drawerInsideStyle:{
       "background":"#293462",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#a64942",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //35 dark-green-yellow-my-color
    textStyle:{
         "color":'#ffe837',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ffe837"
     },drawerInsideStyle:{
       "background":"#103c42",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#05a19c",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //36 dark-blue-yellow-my-color
    textStyle:{
         "color":'#fcf594',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #fcf594"
     },drawerInsideStyle:{
       "background":"#010059",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#ff7a8a",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //37 dark-brown-blue-my-color
    textStyle:{
         "color":'#c1f6e7',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #c1f6e7"
     },drawerInsideStyle:{
       "background":"#4e3440",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#bb7171",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //38 dark-black-white-my-color
    textStyle:{
         "color":'#f6f5f5',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f6f5f5"
     },drawerInsideStyle:{
       "background":"#33313b",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#bb7171",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //39 dark-black-white1-my-color
    textStyle:{
         "color":'#f6f5f5',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #f6f5f5"
     },drawerInsideStyle:{
       "background":"#33313b",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#e3c4a8",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //40 dark-blue-wheat-my-color
    textStyle:{
         "color":'#ffeaa5',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ffeaa5"
     },drawerInsideStyle:{
       "background":"#226b80",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#40a798",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //41 dark-green-orange-my-color
    textStyle:{
         "color":'#ff6337',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ff6337"
     },drawerInsideStyle:{
       "background":"#004a2f",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#002f35",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //42 dark-green-orange2-my-color
    textStyle:{
         "color":'#ffa323',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #ffa323"
     },drawerInsideStyle:{
       "background":"#004a2f",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#002f35",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //43 dark-black-brown-my-color
    textStyle:{
         "color":'#dfddc7',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #dfddc7"
     },drawerInsideStyle:{
       "background":"#211717",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#a34a28",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  },{ //43 dark-purple-blue-my-color
    textStyle:{
         "color":'#8adfdc',
         "padding":"5px",
         "margin":0
       },
    headerStyle:{
       "display":"flex",
       "justify-content":'center',
       "width":"100%",
       "border-bottom": "2px solid #8adfdc"
     },drawerInsideStyle:{
       "background":"#735372",//
     },drawerItemStyle:{
       "display":"flex",
       "justify-content":'flex-start',
       "width":"100%",
     },drawerItemHoverEnterStyle:{
       "cursor": "pointer",
       "background":"#313848",
       "border":"1px solid transparent",
       "border-radius":"5px"
     },drawerItemHoverExitStyle:{
       "cursor": "pointer",
       "background":"transparent",
       "border":"0px"
     }
  }
  ]

  module.exports={
      themes:themes
  }